import { useGetOrganizationUnitsHierachyOptionsQuery } from 'services/organization-units';
import { FindOrganizationUnitHierarchyDto } from 'types';
export function useOrganizationUnitsHierarchyOptions({
  keyword,
  organizationUnitId,
  parentId,
  organizationUnitClassifyId,
  serviceTypeId
}: FindOrganizationUnitHierarchyDto) {
  const {
    data: organizationUnitsResponse,
    error,
    isLoading,
    isFetching,
    refetch
  } = useGetOrganizationUnitsHierachyOptionsQuery({
    keyword,
    organizationUnitId,
    parentId,
    organizationUnitClassifyId,
    serviceTypeId
  });

  return {
    organizationsUnitsHierarchy: organizationUnitsResponse?.data || [],
    isLoading: isFetching || isLoading,
    error,
    refetch
  };
}
